/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Protocol_Audit_ReadyInputs */

const cs_tasks_protocol_audit_ready = /** @type {(inputs: Tasks_Protocol_Audit_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontrolní list je připraven`)
};

const en_tasks_protocol_audit_ready = /** @type {(inputs: Tasks_Protocol_Audit_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audit trail ready`)
};

/**
* | output |
* | --- |
* | "Audit trail ready" |
*
* @param {Tasks_Protocol_Audit_ReadyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_protocol_audit_ready = /** @type {((inputs?: Tasks_Protocol_Audit_ReadyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Protocol_Audit_ReadyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_protocol_audit_ready(inputs)
	return cs_tasks_protocol_audit_ready(inputs)
});